import { Mapper } from "../domain/mappers/Mapper";
import {
    WorksCategoriesDTO,
    WorksCategoriesForm,
} from "../domain/models/dto/WorksCategoriesDTO";
import { SimpleMapper } from "./SimpleMapper";

class WorksCategoriesMapperImpl extends SimpleMapper<
    WorksCategoriesForm,
    WorksCategoriesDTO
> {
    protected toDTOFields: string[] = ["id", "category"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "workId",
        "createdAt",
        "updatedAt",
    ];
}

export default function worksCategoriesMapperFactory(): Mapper<
    WorksCategoriesForm,
    WorksCategoriesDTO
> {
    return new WorksCategoriesMapperImpl();
}
